import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { faqs } from '../data/mockData';

const FAQ = () => {
  return (
    <section 
      id="faq" 
      className="py-24"
      style={{ backgroundColor: '#f8f9fa' }}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 
            className="text-4xl font-bold mb-4"
            style={{ color: '#3B3838' }}
          >
            Preguntas Frecuentes
          </h2>
          <p 
            className="text-lg"
            style={{ color: '#6B7280' }}
          >
            Respuestas a las dudas más comunes sobre nuestros servicios de limpieza profesional.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq) => (
              <AccordionItem 
                key={faq.id} 
                value={`item-${faq.id}`}
                className="bg-white rounded-lg px-6 border-2 border-gray-100"
              >
                <AccordionTrigger 
                  className="text-left font-semibold text-lg hover:no-underline py-6"
                  style={{ color: '#3B3838' }}
                >
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent 
                  className="text-base leading-relaxed pb-6"
                  style={{ color: '#6B7280' }}
                >
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        {/* Bottom CTA */}
        <div 
          className="mt-16 max-w-3xl mx-auto text-center p-8 rounded-xl"
          style={{ backgroundColor: '#E8F2FA' }}
        >
          <h3 
            className="text-2xl font-bold mb-3"
            style={{ color: '#2E75B6' }}
          >
            ¿Tiene Más Preguntas?
          </h3>
          <p 
            className="text-base mb-6"
            style={{ color: '#3B3838' }}
          >
            Nuestro equipo está listo para atenderle y resolver todas sus dudas sobre nuestros servicios.
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-8 py-3 rounded-lg font-semibold transition-all duration-300 hover:scale-105"
            style={{ 
              backgroundColor: '#2E75B6',
              color: 'white'
            }}
          >
            Contactar Ahora
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
